import { useState } from 'react';
import UserMedal from '../interfaces/userMedal';
import { ASSETS_URL } from '../util/constants';

interface MedalModalProps {
  badge: UserMedal;
  onClose: () => void;
  visitor: boolean;
}

const getMedalInfo = (badge: UserMedal) => {
  let tier = 'Shadow';
  let color = '#a1a1a1';
  let tierNum = 0;

  if (badge.quantity >= badge.medal.amountForPlatinum) {
    tier = 'Platinum';
    color = '#A8A8A8';
    tierNum = 4;
  } else if (badge.quantity >= badge.medal.amountForGold) {
    tier = 'Gold';
    color = '#FFD700';
    tierNum = 3;
  } else if (badge.quantity >= badge.medal.amountForSilver) {
    tier = 'Silver';
    color = '#C0C0C0';
    tierNum = 2;
  } else if (badge.quantity >= badge.medal.amountForBronze) {
    tier = 'Bronze';
    color = '#CD7F32';
    tierNum = 1;
  } else {
    tier = 'Shadow';
    color = '#a1a1a1';
    tierNum = 0;
  }
  
  if (badge.medal.medalType.slug === 'collectionables') {
      tier = 'Collectionable';
      color = '#ff8200';
  }


  return {
    tier,
    color,
    tierNum
  };
};

const getImagePath = (tier: string, path: string) => {
  let pathImage = `${ASSETS_URL}/${path}`;
  if (tier === 'Platinum') pathImage += "_Platinum.png";
  else if (tier === 'Gold') pathImage += "_Gold.png";
  else if (tier === 'Silver') pathImage += "_Silver.png";
  else if (tier === 'Bronze') pathImage += "_Bronze.png";
  else if (tier === 'Shadow') pathImage += "_Shadow.png";
  else pathImage = `${ASSETS_URL}${path}`;

  return pathImage;
}

const MedalModal = ({ badge, onClose, visitor }: MedalModalProps) => {
  const { tier, color, tierNum } = getMedalInfo(badge);
  const [currentTier, setCurrentTier] = useState<string>(tier);
  if (!badge) return null;
  
  let currentTierNum = currentTier === "Platinum" ? 4 : currentTier === "Gold" ? 3 : currentTier === "Silver" ? 2 : currentTier === "Bronze" ? 1 : 0

  return (
    <div
      className="modal fade show"
      tabIndex={-1}
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
      onClick={onClose}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div 
          className="modal-content bg-dark text-light border-secondary" 
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header border-secondary">
            <h5 className="modal-title" style={{ color: color }}>
              {badge.medal.name}
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          
          <div className="modal-body text-center">
            <img src={getImagePath(currentTier, badge.medal.pathImage)} alt={badge.medal.name} className="mb-3" style={{ width: "8rem", opacity: currentTierNum > tierNum ? 0.5 : 1 }} />
            
            { tier !== "Collectionable" &&
              <div>
                <img src={`${ASSETS_URL}/${badge.medal.pathImage}_Bronze.png`} alt="Bronze" className="mb-3 mr-1" style={{ width: "3rem", opacity: tierNum < 1 ? 0.2 : 1 }} onClick={() => setCurrentTier("Bronze")} />
                <img src={`${ASSETS_URL}/${badge.medal.pathImage}_Silver.png`} alt="Silver" className="mb-3 mr-1" style={{ width: "3rem", opacity: tierNum < 2 ? 0.2 : 1 }} onClick={() => setCurrentTier("Silver")} />
                <img src={`${ASSETS_URL}/${badge.medal.pathImage}_Gold.png`} alt="Gold" className="mb-3 mr-1" style={{ width: "3rem", opacity: tierNum < 3 ? 0.2 : 1 }} onClick={() => setCurrentTier("Gold")} />
                <img src={`${ASSETS_URL}/${badge.medal.pathImage}_Platinum.png`} alt="Platinum" className="mb-3" style={{ width: "3rem", opacity: tierNum < 4 ? 0.2 : 1 }} onClick={() => setCurrentTier("Platinum")} />
              </div>
            }

            <p className="h5 text-uppercase fw-bold" style={{ color: color, letterSpacing: '1px' }}>
              {currentTier}
            </p>
            
            <hr className="border-secondary" />
            <p className="display-4 fw-bold mb-0">
              {currentTier === "Platinum" && `${badge.quantity.toLocaleString('de-DE')}${tier !== "Platinum" ? `/${badge.medal.amountForPlatinum}` : ""}`}
              {currentTier === "Gold" && `${badge.quantity.toLocaleString('de-DE')}${tier !== "Platinum" ? `/${badge.medal.amountForPlatinum}` : ""}`}
              {currentTier === "Silver" && `${badge.quantity.toLocaleString('de-DE')}${tier !== "Platinum" ? `/${badge.medal.amountForGold}` : ""}`}
              {currentTier === "Bronze" && `${badge.quantity.toLocaleString('de-DE')}${tier !== "Platinum" ? `/${badge.medal.amountForSilver}` : ""}`}
              {currentTier === "Shadow" && `${badge.quantity.toLocaleString('de-DE')}${tier !== "Platinum" ? `/${badge.medal.amountForBronze}` : ""}`}
            </p>
            <p className="text-white">{badge.medal.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MedalModal;